import Polyfills from "./common/Polyfills";
import Globals from "./common/Globals";
import Forms from "./common/Forms.js";
import Header from './components/Header';
import Footer from './components/Footer';
import XHR from "./common/XHR.js";
import Validation from "./common/Validation.js";
import Slider from './components/slider';
// import ValidationEngine from "validation-engine";

// import Slider from './common/Slider';

class Application {
    constructor() {
        new Polyfills();
        new Globals();
        new Forms();
        this.init();
    }

    static onDOMContentLoaded() {
        new Header();
        new Footer();
        new Slider('.testimonialSlider', {
            loop: false
        });
        new Slider('.simulationSlider', {
            loop: false,
            autoplay: {
                delay: 9999999999999,
              },
        });
        Header.RWDMenu();
        
        if (document.querySelector(".policy .header__menu--links a:nth-child(1)")) {
            document.querySelector(".policy .header__menu--links a:nth-child(1)").classList.add("active");
        }
        if (document.querySelector(".private-parking .header__menu--links a:nth-child(2)")) {
            document.querySelector(".private-parking .header__menu--links a:nth-child(2)").classList.add("active");
        }
        if (document.querySelector(".about-us .header__menu--links a:nth-child(3)")) {
            document.querySelector(".about-us .header__menu--links a:nth-child(3)").classList.add("active");
        }
        if (document.querySelector(".blog__menu .header__menu--links a:nth-child(4)")) {
            document.querySelector(".blog__menu .header__menu--links a:nth-child(4)").classList.add("active");
        }
        if (document.querySelector(".contact .header__menu--links a:nth-child(5)")) {
            document.querySelector(".contact .header__menu--links a:nth-child(5)").classList.add("active");
        }

        // new Slider('.js-main-slider', {} );
        // let varintElemOffsetHeight = document.querySelector('.firstTitle').offsetHeight;
        // console.log(varintElemOffsetHeight);

        // let photo = document.querySelector('.author__img');
        // console.log(photo);
        // photo.style.height = varintElemOffsetHeight + 'px';
        // $('.author__img').css('height',varintElemOffsetHeight);

        const hamburger = document.querySelector('.hamburger');
        const nav = document.querySelector('.navigation');
        var logo = document.querySelector('.header__logo');
        var ham = document.querySelector('.ham');
        var body = document.querySelector('body');
        var header = document.querySelector('.header');
        const handleClick = () => {
            hamburger.classList.toggle('hamburger--active');
            nav.classList.toggle('navigation--active');
            logo.classList.toggle('header__logo--active');
            ham.classList.toggle('ham--active');
            body.classList.toggle('body--hamburger');
            header.classList.toggle('header--hamburger');
        }
        hamburger.addEventListener('click', handleClick);

        const moveTo = (dest) => {
            var target = document.querySelector(dest);
            if (target) {
                $('html, body').animate({
                    scrollTop: $(target).offset().top
                }, 1000);
            };
        }
        // $(".more--faq").on("click",function(){

        // });
        $(".rememberSlide__openButton").on("click", function () {
            $(".toogleText").addClass("activeSlide")
            $(".rememberSlide__container").addClass("activeSlide")
            // $(".rememberSlide__openButton").toggleClass("activeSlide")
            document.querySelector(".rememberSlide__openButton").style.display = "none";
            // document.querySelector(".rememberSlide__openButton--text").toggleClass("activeSlide")
            document.querySelector(".rememberSlide__closeButton").style.display = "flex";
        });
        $(".rememberSlide__closeButton").on("click", function () {
            $(".toogleText").removeClass("activeSlide")
            $(".rememberSlide__container").removeClass("activeSlide")
            // $(".rememberSlide__openButton").toggleClass("activeSlide")
            document.querySelector(".rememberSlide__openButton").style.display = "flex";
            // document.querySelector(".rememberSlide__openButton--text").toggleClass("activeSlide")
            document.querySelector(".rememberSlide__closeButton").style.display = "none";
        });
        // $(".rodo-see-less").on("click", function () {
        //     document.querySelector(".rodo-read--more").style.display = "none";
        //     document.querySelector(".rodo-see-more").style.display = "block";
        //     document.querySelector(".rodo-see-less").style.display = "none";
        // });
        // $(".rodo-see-more2").on("click", function () {
        //     document.querySelector(".rodo-read--more2").style.display = "inline";
        //     document.querySelector(".rodo-see-more2").style.display = "none";
        //     document.querySelector(".rodo-see-less2").style.display = "block";
        // });
        // $(".rodo-see-less2").on("click", function () {
        //     document.querySelector(".rodo-read--more2").style.display = "none";
        //     document.querySelector(".rodo-see-more2").style.display = "block";
        //     document.querySelector(".rodo-see-less2").style.display = "none";
        // });

        $("[data-target-scroll]").on("click", function () {
            const target = $(this).attr("data-target-scroll");
            moveTo(target);
        });
        $('.is-floating-label input, .is-floating-label textarea').on('focus blur', function (e) {
            $(this).parents('.is-floating-label').toggleClass('is-focused', (e.type === 'focus' || this.value.length > 0));
        }).trigger('blur');
        const FloatLabel = (() => {
            const bindEvents = (element) => {
                const floatField = element.querySelector('input');
                const floatFieldTextarea = element.querySelector('textarea');
                floatField.addEventListener('focus', handleFocus);
                floatField.addEventListener('blur', handleBlur);
            };
            const init = () => {
                const floatContainers = document.querySelectorAll('.field-float-label');

                floatContainers.forEach((element) => {
                    if (element.querySelector('input').value) {
                        element.classList.add('active');
                    }
                    //   if (element.querySelector('textarea').value) {
                    //     element.classList.add('active');
                    // }    
                    bindEvents(element);
                });
            };

            return {
                init: init
            };
        })();

        FloatLabel.init();
        
        $(document).ready(function(){
            $(".newsletter-form").validationEngine('attach'); 
        });
        const backendErrors = (formSelector) => {
            var rerrors = formSelector;
            if(rerrors.length){
                rerrors.each(function(){
                    var $this = $(this);
                    $this.validationEngine('showPrompt', $this.attr('data-error'), 'error', 'topLeft' , true);
                    $this.click(function(e){
                        $this.validationEngine('hide');
                    })
                })
            }
        }
        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        const asyncForm = (form, type, scroll=false) => {
            var asyncForm = $(form);
            asyncForm = $(form).validationEngine({
                promptPosition: "topLeft",
                scroll: scroll,
                scrollOffset: 80
            });
            var url = url;
            var data = data;
            var ajaxResponse = null;
            asyncForm.submit(function(e){
                
                var _ = $(this);
                e.preventDefault();
                var url = $(this).attr('data-url');
                var method = $(this).attr('method') || "GET";
                var data = $(this).find('input:not(:checkbox), input:not(:radio), select, textarea, input:checked');
                console.log(data[0].value)
                if(validateEmail(data[0].value)){
                    var mask = $('<div class="mask" style="z-index:1000; display: block; position: absolute; top: 0; left: 0; width: 100%; min-height: 12px; background: url(\'' + window.BASEURL + '/frontend/template/public/assets/css/resources/ajax-loader.gif\') no-repeat center);"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="45" width="45" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg></div></div>');
                    App.responseTimeout ? clearTimeout(App.responseTimeout) : "";
                    if(url){
                        App.responseTimeout = setTimeout(function() {
                            var formData = new FormData();
                            if(data.length){
                                data.each(function(){
                                    if($(this).attr('type') !== 'file'){
                                        formData.append($(this).attr('name'), $(this).val());
                                    }else{
                                        formData.append($(this).attr('name'), $(this)[0].files[0]);
                                    }  
                                })
                            }
                            if (window.xhr == null /*&& _.validationEngine('validate')*/) {
                                window.xhr = 1;
                                _.prepend(mask);
                                $.ajax({
                                    url: url,
                                    data: _.serialize(),
                                    type: method,
                                    success: function(data){
                                    
                                        data = jQuery.parseJSON(data);
                                        asyncForm.find('input, textarea').attr('data-error',"").removeClass('formRerror');
                                    
                                        if(data.redirect != false && typeof data.redirect != "undefined"){
                                            window.location.replace(data.redirect);
                                        }
                                    
                                        if(data.errors != false && typeof data.errors != "undefined"){
                                            $.each(data.errors, function(i,item){
                                                asyncForm.find('[name="'+i+'"]').attr('data-error',item).addClass('formRerror');
                                            });
                                        }                      
                                    
                                        var $old_msg = _.find(".msg");

                                        setTimeout(function(){
                                            // App.backendErrors(asyncForm.find('.formRerror')); 
                                            $old_msg.remove();
                                        }, 550);
                                    
                                        var template = '<div class="msg msg-{{type}} inactive"><div class="msg-body">{{text}}</div></div>';

                                        if(data.msg != '' && typeof data.msg != "undefined"){
                                            if(data.success == false){
                                                template = template.replace('{{text}}', data.msg);
                                                template = template.replace('{{type}}', 'error');
                                            } else{
                                                template = template.replace('{{text}}', data.msg);
                                                template = template.replace('{{type}}', 'success');
                                            }
                                            var responseMsg = template;
                                        }
                                    
                                    
                                        setTimeout(function(){
                                            (type == "append") ? _.append(responseMsg) : _.prepend(responseMsg);
                                        }, 600);
                                    
                                        setTimeout(function(){
                                            _.find(".msg").eq(0).removeClass('inactive');
                                        }, 650);
                                    
                                        if(data.scroll == true){
                                            setTimeout(function(){
                                                let newMsg = _.find(".msg");
                                                if (!newMsg.length) return false;
                                                let offset = newMsg.offset().top;
                                                (type == "append") ? offset -= newMsg.outerHeight() : offset -= 100; 
                                                $('html, body').animate({
                                                    scrollTop: offset
                                                }, 600)
                                            }, 650);
                                        }
                                    
                                        if(data.scrollToError == true && data.scroll == false){
                                            setTimeout(function(){
                                                let offset = $('.formError').eq(0).offset().top;
                                                $('html, body').animate({
                                                    scrollTop: offset - 80
                                                })
                                            }, 650);
                                        }
                                    
                                        if(data.success){
                                            setTimeout(function(){
                                                asyncForm.find("input[type='text'], input[type='email'],input[type='tel'], input[type='checkbox'], textarea").val("");
                                            }, 650)
                                        }
                                    
                                        if (typeof data.customEvent != "undefined") {
                                            switch(data.customEvent) {
                                                case 'reviews':
                                                if (data.success == true) {
                                                    let review = data.html;
                                                    let promoReview = false;
                                                    if ($('.reviews__list .single__review--promo').length) promoReview = true;
                                                    if (promoReview) {
                                                        $(review).insertAfter('.reviews__list .single__review--promo');
                                                    } else {
                                                        $('.reviews__list').prepend(review);
                                                    }
                                                    setTimeout(function(){
                                                        $('.reviews--page .reviews-top').slideUp();
                                                    }, 450);
                                                    setTimeout(function(){
                                                        $('.reviews__list').find('.single__review').removeClass('hidden-add');
                                                    }, 500);
                                                    setTimeout(function(){
                                                        $('.reviews__list').find('.single__review').removeClass('bg-add');
                                                    }, 2000);
                                                }
                                                break;
                                            
                                                case 'brochure':
                                                if (data.success == true) {
                                                    let template = '<a class="download-brochure btn btn-standard btn-black hidden" href="{{link}}" download>{{name}}</a>';
                                                    template = template.replace('{{link}}', data.link);
                                                    template = template.replace('{{name}}', data.name);
                                                    setTimeout(function(){
                                                        $('.order-a-brochure__left form').addClass('hidden');
                                                    }, 1000);
                                                    setTimeout(function(){
                                                        $('.order-a-brochure__left form').remove();
                                                        $(template).insertAfter('.order-a-brochure__left .content');
                                                    }, 1200);
                                                    setTimeout(function(){
                                                        $('.order-a-brochure__left .download-brochure').removeClass('hidden');
                                                    }, 1400);
                                                }
                                            }
                                        }
                                    
                                        window.xhr = null;
                                        setTimeout(function(){
                                            mask.remove();
                                        }, 800);
                                    },
                                    error: function() {
                                        mask.remove();
                                    }
                                });
                            }
                        }, 400);
                    }
                }else{
                    var $old_msg = _.find(".msg");
                    $old_msg.remove();
                    const errorMsg = document.createElement('div')
                    errorMsg.className = 'msg msg-error mailFalse'
                    const errorMsgBody = document.createElement('div')
                    errorMsgBody.className = 'msg-body'
                    errorMsgBody.innerHTML = 'Błędny mail'
                    errorMsg.appendChild(errorMsgBody);
                    const newsletter = document.querySelector('.newsletter-form')
                    newsletter.appendChild(errorMsg);
                }
            })
        }
        asyncForm('.newsletter-form' , 'append');
        
    }

    static onLoad() { }

    static onResize() {

    }

    init() {
        
        document.addEventListener('DOMContentLoaded', () => {
            this.constructor.onDOMContentLoaded();
        }, false);
        
        window.onload = () => this.constructor.onLoad();

        window.onresize = () => this.constructor.onResize();
    }
}

const App = new Application();
const accordions = document.querySelectorAll('.accordion');
const handleClick = accordion => () => {
    const prevState = accordion.selected;
    // let clicked = accordion.querySelector(".accordion__head--content");
    if (accordion.dataset.multiselect !== undefined && accordion.dataset.multiselect === 'disabled') {
        [].forEach.call(accordions, accordion => {
            accordion.selected = false;
        });
    }

    accordion.selected = !prevState;

    [].forEach.call(accordions, accordion => {
        const container = accordion.querySelector('.accordion__container');

        if (accordion.selected) {
            container.style.height = accordion.querySelector('.accordion__body').offsetHeight + 'px';
            accordion.setAttribute('aria-expanded', true);
            accordion.querySelector(".accordion__head--after").style.display = "none";
            accordion.querySelector(".accordion__container").classList.add("openedFaq");
        } else {
            container.style.height = null;
            accordion.setAttribute('aria-expanded', false);
            accordion.querySelector(".accordion__head--after").style.display = "inline";
            accordion.querySelector(".accordion__container").classList.remove("openedFaq");
        }
    });
};

[].forEach.call(accordions, accordion => {
    accordion.querySelector('.accordion__head').addEventListener('click', handleClick(accordion));
});



// WEBPACK FOOTER //
// ./src/assets/js/App.js